<template>
  <span class="user-tag">
    <user-avatar size="20px" class="user-tag__avatar" :member="props.member" />
    <span class="tw-mr-1">
      {{ props.member?.user.name }}
    </span>
    <octicon
      v-if="props.closable"
      icon="x"
      class="user-tag__close-icon"
      :width="12"
      :height="12"
      @click="emit('closed')"
    />
  </span>
</template>

<script setup lang="ts">
import { OrganizationMembership } from '@/models/user.models';
import { defineProps, withDefaults, defineEmits } from 'vue';
import { UserAvatar } from '@/components/avatars';

interface Props {
  member: OrganizationMembership;
  closable?: boolean;
}
interface Emits {
  (e: 'closed'): void;
}

const props = withDefaults(defineProps<Props>(), {
  closable: false,
});
const emit = defineEmits<Emits>();
</script>

<style lang="scss" scoped>
.user-tag {
  @apply tw-bg-gray-light tw-pr-1 tw-text-gray-dark tw-text-xs tw-font-medium tw-inline-flex tw-items-center tw-relative;
  height: 24px;
  border-radius: 24px;

  &__avatar {
    @apply tw-flex-shrink-0 tw-mx-1;
  }

  &__close-icon {
    @apply tw-text-gray-medium-dark tw-text-xs tw-cursor-pointer;
    &:hover {
      @apply tw-text-gray-dark;
    }
  }
}
</style>
